import React from "react";

import { JollyRancherChip, type JollyRancherChipColor } from "veneer/Chip";
import Typography from "veneer/Typography";

interface PriorityPresentation {
  color: JollyRancherChipColor;
  label: string;
}

const PRIORITY_PRESENTATIONS: Record<string, PriorityPresentation> = {
  critical: { color: "red", label: "Critical" },
  info: { color: "green", label: "Information" },
  warning: { color: "yellow", label: "Warning" },
};

export function getIncidentPriorityLabel(priority: string): string {
  return PRIORITY_PRESENTATIONS[priority]?.label ?? priority;
}

interface IncidentPriorityProps {
  priority?: string | null;
}

export default function IncidentPriority({ priority }: IncidentPriorityProps) {
  if (!priority) {
    return null;
  }

  const presentation = PRIORITY_PRESENTATIONS[priority];

  if (!presentation) {
    return (
      <Typography dataTestId="incident-priority" variant="body2">
        {priority}
      </Typography>
    );
  }

  return (
    <JollyRancherChip
      color={presentation.color}
      dataTestId="incident-priority"
      label={presentation.label}
    />
  );
}
